import { useCallback, useMemo } from "react";
import { useWatch } from "react-hook-form";

import { useGetCountries } from "api/queries/common/useGetCountries";
import { ScheduleStopValue } from "pages/shipper/RequestFormV2/defaults/scheduleDefaults";
import { buildStopSummary } from "@RequestFormV2/components/RequestFormHeader/utils/scheduleSummary";

export function useScheduleHeaderSummary() {
  const stops = useWatch({ name: "schedule.stops" }) as ScheduleStopValue[] | undefined;
  const { data: countries = [] } = useGetCountries({
    useV2: true,
    refetchOnMount: false,
  });

  const getCountryCodeById = useCallback(
    (countryId?: number | string) => {
      if (!countryId) return "";
      const country = countries.find((entry) => String(entry.id) === String(countryId));
      return country?.code ?? "";
    },
    [countries],
  );

  return useMemo(
    () => ({
      pickupSummary: buildStopSummary(stops?.[0], getCountryCodeById(stops?.[0]?.country_id)),
      deliverySummary: buildStopSummary(stops?.[1], getCountryCodeById(stops?.[1]?.country_id)),
    }),
    [stops, getCountryCodeById],
  );
}
